<template>
  <div id="pbd-lm" class="sticky-menu" :class="type">
    <div class="pbd-wrap">
      <div
        v-for="op in options"
        :key="op"
        class="menu-option"
        :class="selectedPbd === op && 'selected'"
        @click="() => changeMenuOp(op)"
      >
        {{ $t(op) }}
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  components: {},
  props: {
    selectedPbd: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      options: ['stat_content', 'stat_use', 'profiles_use'],
    }
  },
  methods: {
    changeMenuOp(option) {
      this.$emit('change-pbd', option)
    },
  },
}
</script>

<style lang="stylus" scoped>
.sticky-menu
  position: sticky
  top: "calc(%s)" % $subheader-height
  overflow-y: visible
  width: vw(150px)
  height: 0
  z-index: 2

  &.embed
    top: 0

  .mobile &
    top: "calc(%s + %s)" % ($header-height $subheader-height)
    width: 100%
    height: auto
    border: 1px solid $light-grey

.pbd-wrap
  width: 100%
  height: 100vh
  background-color: #fff
  text-align: center

  .mobile &
    display: flex
    height: auto

  .menu-option
    m-font-size(14, 18)
    display: flex
    justify-content: center
    align-items: center
    padding: vw(30px) vw(25px)
    min-height: vw(120px)
    font-weight: 400
    cursor: pointer

    .mobile &
      flex: 1 1 0%
      padding: vw(20px) vw(10px)
      min-height: auto

    &:hover
      background-color: $corpotative-color-very-light

    &.selected
      background-color: $lighter-blue
      box-shadow: 4px 0 0 0 $corporate_color inset
      color: $corporate_color
      cursor: default

      .mobile &
        box-shadow: 0 -4px 0 0 $corporate_color inset
</style>
